var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive",attrs:{"id":"printTargetDiv"}},[_c('table',{staticClass:"table"},[_c('thead',{staticClass:"table-light"},[_c('tr',[_vm._t("header")],2)]),_c('tbody',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }